import React, { useState } from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import ZoomTransformWrapper from "../Room/ZonePlanner/ZoomTransformWrapper";

export interface DashboardMapElementProps {
  onMapLoadingError?: () => void;
}

const DashboardMap: React.FC<{
  children: React.ReactElement<DashboardMapElementProps>;
  fullScreenProps?: { isFullScreen: boolean; onFullScreenClick?: () => void };
  additionalControls?: React.ReactNode;
  showEnableFullScreenAlways?: boolean;
  mapLoadingErrorProps: { errorText: string; errorButtonText?: string; errorButtonClickHandler?: () => void };
}> = ({ children, fullScreenProps, additionalControls, showEnableFullScreenAlways, mapLoadingErrorProps }) => {
  const [mapLoadingError, setMapLoadingError] = useState<boolean>(false);
  const [wrapperDivRef, setWrapperDivRef] = useState<HTMLDivElement | null>(null);

  return (
    <Card sx={{ height: "100%" }}>
      <div
        id="dashboard-map"
        ref={(newRef) => setWrapperDivRef(newRef)}
        style={{
          height: "100%",
          width: "100%",
          backgroundColor: "#F2F4F7",
          position: "relative",
          transition: "height 0.3s ease-in-out",
        }}
      >
        {!mapLoadingError && wrapperDivRef != null && (
          <ZoomTransformWrapper
            showRecenter
            showFullScreen
            showEnableFullScreenAlways={showEnableFullScreenAlways}
            fullContent
            onFullScreenChange={fullScreenProps?.onFullScreenClick}
            fullScreen={fullScreenProps?.isFullScreen}
            additionalControls={additionalControls}
          >
            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
              {React.cloneElement(children, {
                onMapLoadingError: () => {
                  setMapLoadingError(true);
                  children.props.onMapLoadingError?.();
                },
              })}
            </div>
          </ZoomTransformWrapper>
        )}

        {mapLoadingError && (
          <Box sx={{ px: 2, height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Alert
              severity="warning"
              action={
                mapLoadingErrorProps.errorButtonText && mapLoadingErrorProps.errorButtonClickHandler ? (
                  <Button color="inherit" size="small" onClick={mapLoadingErrorProps.errorButtonClickHandler}>
                    {mapLoadingErrorProps.errorButtonText}
                  </Button>
                ) : null
              }
            >
              {mapLoadingErrorProps.errorText}
            </Alert>
          </Box>
        )}
      </div>
    </Card>
  );
};

export default DashboardMap;
